<template>
  <DashboardWidget class="widget-bar-stack" :loading="loading" :title="title">
    <v-chart :options="chart" :autoresize="true" />
  </DashboardWidget>
</template>

<script>

import ECharts from 'vue-echarts';
import 'echarts/lib/chart/bar';
import 'echarts/lib/component/legend';
import 'echarts/lib/component/tooltip';

export default {
  name: 'dashboard-widget-bar-stack',
  components: {
    DashboardWidget: () => import('../DashboardWidget'),
    'v-chart': ECharts,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    dataY: {
      type: Array,
      required: true,
    },
    dataX: {
      type: Array,
      required: true,
    },
    legendData: {
      type: Array,
    },
  },
  data () {
    return {
      loading: false,
      chart: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        legend: {
          data: this.legendData,
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true,
        },
        xAxis: [
          {
            type: 'category',
            data: this.dataX,
          },
        ],
        yAxis: [
          {
            type: 'value',
          },
        ],
        series: this.dataY,
      },
    };
  },
};

</script>

<style lang="scss">

.widget-bar-stack {
  .echarts {
    width: 100%;
    height: 100%;
  }
}

</style>
